import React from 'react';
import './Clientes-Modal.css'; // Asegúrate de que este CSS contenga los estilos mejorados
//import inversor from './assets/Humilladero/inversor.jpeg';
import DancarMp4 from './assets/HotelDancar/Hotel_Dancar.mp4';

const HotelDancar = () => {
  return (
    <div className="container">
      <h2>✅ Proyecto: Hotel DANCAR Pamplona 🌞✨ </h2>
      <p>
        <video controls>
          <source src={DancarMp4} type="video/mp4" />
          Tu navegador no soporta la reproducción de video.
        </video>
        <span className="highlight">
          {' '}
          Energía limpia para una experiencia de hospedaje más eficiente,
          sostenible y moderna.{' '}
        </span>
        <br />
        <br />
        En el Hotel DANCAR Pamplona, uno de los establecimientos de hospedaje
        con mayor actividad en la ciudad, instalamos un sistema solar
        fotovoltaico conectado a la red con una capacidad de 13.79 kWp,
        conformado por 20 paneles solares de alta eficiencia y un inversor
        multicanal de 15 kW.
        <br />
        <br />
        Este sistema permite gestionar de manera estable y segura las cargas
        eléctricas del hotel, optimizando el desempeño energético y garantizando
        una operación continua en áreas como: recepción, habitaciones y equipos
        de uso diario.
        <br />
        <br />
        Los objetivos de este proyecto fueron:
        <br />
        <br />✔ Reducir los costos operativos asociados al consumo eléctrico
        del hotel.
        <br />✔ Incorporar una solución sostenible y alineada con las prácticas
        de turismo responsable.
        <br />✔ Garantizar energía constante para las actividades diarias y el
        confort de los huéspedes.
        <br />
        <br />
        Hoy, el Hotel DANCAR genera su propia energía limpia, disminuyendo
        significativamente los costos mensuales de electricidad y aumentando su
        competitividad al implementar una solución energética moderna y
        sostenible.
        <br />
        <br />
        Con esta instalación, el hotel no solo reduce costos, sino que también
        fortalece su propuesta de valor: ofrecer una experiencia de hospedaje
        con responsabilidad ambiental.
        <span className="highlight">
          <br />
          <br />
          Este proyecto cuenta con el acompañamiento de IPSUM Ingeniería e
          Innovación, ofreciendo:
        </span>
        <br />
        <br />
        🔧 Soporte técnico y mantenimiento preventivo
        <br />
        🔧 Monitoreo del sistema para garantizar máxima eficiencia energética
        <br />
        🔧 Instalación estructural segura, diseñada para prolongar la vida útil
        del sistema y facilitar su mantenimiento.
        <br />
        🔧 Capacitación al usuario en el manejo de la aplicación de monitoreo.
        <br />
        🔧 Acompañamiento presencial de nuestros ingenieros durante y después de
        la instalación.
        <br />
        <br />
        Una decisión inteligente que combina ahorro, sostenibilidad y una mejor
        experiencia para sus huéspedes.
      </p>
    </div>
  );
};

export default HotelDancar;
